import { Validator } from 'fluentvalidation-ts';
import { uniqueId } from 'lodash';
import { beAnInteger, bePositiveNumber } from '../../validators/stringValidators';
import { BillOfMaterialsItemResponse, BillOfMaterialsPartsById } from './dataForEditBillOfMaterialsForm';

export type BillOfMaterialsItemFormModel = {
  id: string;
  billOfMaterialsItemId: number | null;
  partId: number;
  quantity: string;
  costInPounds: number | null;
  priceInPounds: number | null;
  isDeleted: boolean;
  partIsInactiveValidation: null; // Placeholder property
};

export const mapBillOfMaterialsItemToFormModel = (
  billOfMaterialsItem: BillOfMaterialsItemResponse,
): BillOfMaterialsItemFormModel => ({
  id: uniqueId('bom_item'),
  billOfMaterialsItemId: billOfMaterialsItem.billOfMaterialsItemId,
  partId: billOfMaterialsItem.partId,
  quantity: billOfMaterialsItem.quantity.toString(),
  costInPounds: billOfMaterialsItem.costInPounds,
  priceInPounds: billOfMaterialsItem.priceInPounds,
  isDeleted: billOfMaterialsItem.isDeleted,
  partIsInactiveValidation: null,
});

export class BillOfMaterialsItemFormModelValidator extends Validator<BillOfMaterialsItemFormModel> {
  constructor(partsById: BillOfMaterialsPartsById) {
    super();

    this.ruleFor('quantity')
      .notEmpty()
      .must(beAnInteger)
      .must(bePositiveNumber);

    this.ruleFor('partIsInactiveValidation')
      .must((_, item) => item.isDeleted || item.partId == null || !partsById[item.partId].isInactive)
      .withMessage('This Part is marked as inactive');
  }
}

export type BillOfMaterialsItemsFieldNames = 'underfloorHeatingItems' | 'heatPumpItems' | 'solarItems';

export const assistDesignChargePartCode = 'MPDPCD-C';
export const totalDesignChargePartCode = 'MPDP-C';

export const itemIsDesignCharge = (item: BillOfMaterialsItemFormModel, partsById: BillOfMaterialsPartsById) =>
  itemIsAssistDesignCharge(item, partsById) || itemIsTotalDesignCharge(item, partsById);

export const itemIsAssistDesignCharge = (item: BillOfMaterialsItemFormModel, partsById: BillOfMaterialsPartsById) =>
  item.partId in partsById && partsById[item.partId].name == assistDesignChargePartCode;

export const itemIsTotalDesignCharge = (item: BillOfMaterialsItemFormModel, partsById: BillOfMaterialsPartsById) =>
  item.partId in partsById && partsById[item.partId].name == totalDesignChargePartCode;
